<template>
  <!-- RELATÓRIO -->
  <div style="color: #bdc0c1">
    <RelatorioRetrato>
      <div class="fundoRelatorio titulo">
        <img style="max-width: 200px" clas="mb-1" :src="logoGenialBase64" alt="logoGenial" />

        <div class="lineBlue"></div>
        <div class="lineGray"></div>
      </div>

      <h1 style="text-align: center; font-size: 20px; color: #615771">Simulação</h1>
      <b-row>
        <b-col cols="21" sm="6" class="d-flex justify-content-between flex-column">
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 style="font-size: 16px">{{ parametro.nome }}</h4>
                <span style="font-size: 14px">CPF: {{ parametro.cpf }}</span
                ><br />
                <span style="font-size: 14px">
                  Proposta:
                  <b-badge variant="success" pill style="color: white">
                    {{ parametro.codigo }}
                  </b-badge>
                </span>
                <br />
                <span style="font-size: 14px"
                  >Data da Proposta:
                  <b-badge variant="success" pill style="color: white">
                    {{ parametro.createdAt }}
                  </b-badge> </span
                ><br />
                <span style="font-size: 12px"> <b>Proposta válida para esta data, sujeito à alteração</b> </span>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" sm="6">
          <table class="mt-2 mt-xl-0 w-100" aria-describedby="gridRelatorio">
            <tr>
              <th class="pb-50" style="margin: 1px">
                <feather-icon icon="BriefcaseIcon" style="margin-right: 5px" />
                <span class="font-weight-bold" style="font-size: 14px">Órgão</span>
              </th>
              <td style="font-size: 14px" class="pb-50">
                {{ parametro.nomeOrgao }}
              </td>
            </tr>
            <tr>
              <th style="width: 97px; margin: 1px" class="pb-50">
                <feather-icon icon="StarIcon" class="mr-75" style="margin-right: 5px" />
                <span class="font-weight-bold" style="font-size: 14px">Categoria</span>
              </th>
              <td style="font-size: 14px" class="pb-50 text-capitalize">
                {{ parametro.categoria }}
              </td>
            </tr>
            <tr>
              <th>
                <feather-icon icon="PhoneIcon" class="mr-75" style="margin-right: 5px" />
                <span class="font-weight-bold" style="font-size: 14px">Telefone</span>
              </th>
              <td style="font-size: 14px">
                {{ parametro.telefone }}
              </td>
            </tr>
            <tr>
              <th>
                <feather-icon icon="AtSignIcon" class="mr-75" style="margin-right: 5px" />
                <span class="font-weight-bold" style="font-size: 14px">E-mail</span>
              </th>
              <td style="font-size: 14px">
                {{ parametro.email }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>

      <section style="background-color: white">
        <div class="fundoRelatorio cabecalhoTable">
          <b-row class="mt-2">
            <b-col sm="4">
              <b-form-group label="Valor Liberado" label-for="valor">
                <b-form-input
                  id="valor"
                  :placeholder="parametro.valorBaseCalculo"
                  v-model="parametro.valorBaseCalculo"
                  :readonly="true"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="4">
              <b-form-group label="Valor do IOF" label-for="valorIOF">
                <b-form-input id="valorIOF" :placeholder="parametro.valorIOF" :value="parametro.valorIOF" :readonly="true" />
              </b-form-group>
            </b-col>

            <b-col sm="4">
              <b-form-group label="Valor Financiado" label-for="valorComIOF">
                <b-form-input
                  id="valorComIOF"
                  :placeholder="parametro.valorComIOF"
                  :value="parametro.valorComIOF"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group label="Valor da Parcela" label-for="valorPrimeiraParcela">
                <b-form-input
                  id="valorPrimeiraParcela"
                  :placeholder="parametro.valorPrimeiraParcela"
                  v-model="parametro.valorPrimeiraParcela"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="Parcelas" label-for="parcelas">
                <b-form-input id="parcelas" :placeholder="parametro.parcelas" v-model="parametro.parcelas" :readonly="true" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="1º Parcela" label-for="primeiraParcela">
                <b-form-input
                  id="primeiraParcela"
                  class="form-control"
                  type="text"
                  :placeholder="parametro.primeiraParcela"
                  v-model="parametro.primeiraParcela"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="Valor Final" label-for="valorFinal">
                <b-form-input
                  id="valorFinal"
                  :placeholder="parametro.valorFinal"
                  v-model="parametro.valorFinal"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group label="Taxa Mensal" label-for="taxa">
                <b-form-input id="taxa" :placeholder="parametro.taxa" :value="parametro.taxa" :readonly="true" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="Taxa Anual" label-for="taxaAnual">
                <b-form-input id="taxaAnual" :placeholder="parametro.taxaAnual" :value="parametro.taxaAnual" :readonly="true" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="CET Mensal" label-for="taxaEfetivaMensal">
                <b-form-input
                  id="taxaEfetivaMensal"
                  :placeholder="parametro.taxaEfetivaMensal"
                  :value="parametro.taxaEfetivaMensal"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label="CET Anual" label-for="taxaEfetivaAnual">
                <b-form-input
                  id="taxaEfetivaAnual"
                  :placeholder="parametro.taxaEfetivaAnual"
                  :value="parametro.taxaEfetivaAnual"
                  :readonly="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <template v-for="(pageItems, pageIndex) in paginatedItems">
                <b-table striped responsive :style="tableStyle(pageIndex)" :items="pageItems" :fields="parametro.fields">
                  <template #cell(valor)="row">
                    {{ formatarValor(row.item.valor) }}
                  </template>
                  <template #cell(vencimento)="row">
                    {{ formatarData(row.item.vencimento) }}
                  </template>
                </b-table>
              </template>
            </b-col>
          </b-row>
        </div>
      </section>
    </RelatorioRetrato>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { formatarValor, formatarData } from '@/utils/Functions/Formatacao/Formatacao'
  import RelatorioRetrato from '../../relatorio/relatorioRetrato.vue'
  import { logoGenialBase64 } from '@/assets/images/logo/logoGenial.js'
  export default {
    components: {
      ValidationProvider,
      ValidationObserver,
      RelatorioRetrato,
    },
    props: {
      parametro: {},
    },
    data() {
      return {
        logoGenialBase64,
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        formatarData,
        formatarValor,
      }
    },

    computed: {
      paginatedItems() {
        const firstPageItems = 13
        const itemsPerPage = 25
        const pages = []

        if (this.parametro.dados.length > 0) {
          pages.push(this.parametro.dados.slice(0, firstPageItems))
        }

        for (let i = firstPageItems; i < this.parametro.dados.length; i += itemsPerPage) {
          pages.push(this.parametro.dados.slice(i, i + itemsPerPage))
        }

        return pages
      },
    },

    methods: {
      tableStyle(pageIndex) {
        return {
          textAlign: 'center',
          pageBreakInside: pageIndex === this.paginatedItems.length - 1 ? 'avoid' : 'auto',
          pageBreakAfter: pageIndex === this.paginatedItems.length - 1 ? 'auto' : 'always',
        }
      },
    },
  }
</script>
